'use strict';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/es/json';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/string';
import 'core-js/es/object';
import 'core-js/features/array/find';
import 'core-js/features/array/includes';
import 'core-js/features/number/is-nan';

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}

require('url-search-params-polyfill');



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 384
// module chunks = 0 1 2 3 4 5 6 7 8 9 10